import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Documents from "./Documents";
import { LogOut } from "lucide-react";

const InvestorPortal = () => {
  const { user, loading, logout } = useAuth();
  if (loading) return <div className="pt-[120px] text-center text-[#F3EEE3]/50">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="bg-[#12201A]">
      <div className="pt-[64px]">
        <div className="max-w-[1100px] mx-auto px-5 md:px-8 pt-10 flex items-center justify-between">
          <div>
            <p className="eyebrow text-[#C9B79C]">Investor Portal</p>
            <p className="text-[#F3EEE3]/60 text-sm mt-1">Signed in as {user.email}</p>
          </div>
          <button onClick={logout} className="inline-flex items-center gap-2 text-sm text-[#F3EEE3]/70 hover:text-[#F3EEE3] border border-[#F3EEE3]/20 rounded-full px-4 py-2"><LogOut size={14} /> Sign out</button>
        </div>
      </div>
      <Documents />
    </div>
  );
};

export default InvestorPortal;
